<div class="page-container">
  <div class="header-section">
    <div class="title-block">
      <h1>Laboratory Details</h1>
    </div>

    <div class="header-actions">
      <button class="btn-secondary" (click)="openCancelDialog()">
        <span class="material-icons">arrow_back</span> Back
      </button>
      <button class="btn-primary" (click)="saveLaboratory()">
        <span class="material-icons">save</span> Save
      </button>
    </div>
  </div>

  <div class="form-card" *ngIf="laboratory">
    <div class="form-grid-layout">

      <div class="form-group full-width">
        <label class="form-label">Laboratory Name</label>
        <input pInputText [(ngModel)]="laboratory.title" placeholder="Enter laboratory name..." />
      </div>

      <div class="form-group">
        <label class="form-label">Street</label>
        <input pInputText [(ngModel)]="laboratory.street" placeholder="Street & No." />
      </div>

      <div class="form-group">
        <label class="form-label">Country</label>
        <p-select [filter]="true" [options]="availableCountrys" optionLabel="title" optionValue="countryId"
          [(ngModel)]="selectedCountryId" placeholder="Select Country">
        </p-select>
      </div>

      <div class="form-group">
        <label class="form-label">ZIP Code</label>
        <input pInputText [(ngModel)]="laboratory.zip" placeholder="ZIP" />
      </div>

      <div class="form-group">
        <label class="form-label">City</label>
        <input pInputText [(ngModel)]="laboratory.city" placeholder="City" />
      </div>

      <div class="form-group full-width mt-3">
        <div class="toggle-grid">
          <label class="toggle-item">
            <input type="checkbox" [ngModel]="laboratory.isStandard"
              (ngModelChange)="onStatusToggle('isStandard', $event)" />
            <span>Is Standard</span>
          </label>
          <label class="toggle-item">
            <input type="checkbox" [ngModel]="laboratory.isSampleLabStandard"
              (ngModelChange)="onStatusToggle('isSampleLabStandard', $event)" />
            <span>Is Sample Lab Standard</span>
          </label>
        </div>
      </div>

      <div class="form-group full-width mt-4">
        <div class="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 class="card-title">Contact Persons</h3>
          <button class="card-action-btn" (click)="addHandler()">
            <span class="material-icons">person_add</span> Add Contact
          </button>
        </div>

        <div class="grid-container-scroll">
          <p-table [value]="contactPersons" [paginator]="true" [rows]="gridState.take ?? 5" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th style="width: 90px">Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-dataItem>
              <tr>
                <td><input pInputText [(ngModel)]="dataItem.firstName" placeholder="First Name" /></td>
                <td><input pInputText [(ngModel)]="dataItem.lastName" placeholder="Last Name" /></td>
                <td>
                  <button class="btn-delete" (click)="removeHandler(dataItem)" style="border:none;">
                    <span class="material-icons" style="color: var(--labtech-status-error)">delete_outline</span>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-container *ngIf="cancelDialog">
  <p-dialog [modal]="true" [visible]="true" header="Please Confirm" (onHide)="toggleCancelDialog()" [style]="{ width: '450px' }">
    <p style="margin: 30px; font-weight: 500; text-align: center;">
      Are you sure you want to discard the changes?
    </p>
    <ng-template pTemplate="footer">
      <button class="btn-secondary" (click)="toggleCancelDialog()">No</button>
      <button class="btn-primary" (click)="cancelHandler()">Yes</button>
    </ng-template>
  </p-dialog>
</ng-container>

<ng-container *ngIf="statusChangeDialog">
  <p-dialog [modal]="true" [visible]="true" header="Change laboratory standard" (onHide)="closeStatusChangeDialog()" [style]="{ width: '480px' }">
    <p style="margin: 24px 30px 12px; font-weight: 500; text-align: center;">
      <strong>{{ pendingStatusLaboratoryName }}</strong> currently has the status <strong>{{ pendingStatusLabel
        }}</strong>.
    </p>
    <p style="margin: 0 30px 24px; text-align: center;">
      If you continue, the status will be removed there and set for this laboratory.
    </p>
    <ng-template pTemplate="footer">
      <button class="btn-secondary" (click)="closeStatusChangeDialog()">Cancel</button>
      <button class="btn-primary" (click)="confirmStatusChange()">Continue</button>
    </ng-template>
  </p-dialog>
</ng-container>
